export default __webpack_public_path__ + "ac1caf3e5db0e8e80d06ae825783853d.png";